var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".dragging[data-v-289fd4cd] {\n  opacity: 0.4;\n}\n.bank-drag[data-v-289fd4cd] {\n  cursor: grab;\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _defineProperty3.default)({
  props: {
    gateways: {
      type: Array,
      required: true
    },
    csrf_token: {
      type: String,
      required: true
    },
    gateways_hidden_on_checkout: {
      type: Array,
      required: true
    }
  },

  data: function data() {
    return {
      banks: [].concat((0, _toConsumableArray3.default)(this.gateways)),
      draggingIndex: null,
      search: "",
      localHiddenGatewayIds: [].concat((0, _toConsumableArray3.default)(this.gateways_hidden_on_checkout))
    };
  },


  computed: {
    filteredBanks: function filteredBanks() {
      var _this = this;

      if (!this.search) return this.banks;

      return this.banks.filter(function (b) {
        return b.name.toLowerCase().includes(_this.search.toLowerCase());
      });
    },
    hiddenGatewayIds: function hiddenGatewayIds() {
      return this.localHiddenGatewayIds;
    }
  },
  methods: {
    isGatewayHidden: function isGatewayHidden(bankId) {
      return this.hiddenGatewayIds.includes(String(bankId));
    }
  },
  mounted: function mounted() {}
}, "methods", {
  onDragStart: function onDragStart(index) {
    this.draggingIndex = index;
  },
  onDragOver: function onDragOver(index) {},
  onDrop: function onDrop(index) {
    if (this.draggingIndex === null) return;

    var draggedItem = this.banks[this.draggingIndex];

    this.banks.splice(this.draggingIndex, 1);

    this.banks.splice(index, 0, draggedItem);

    this.draggingIndex = null;

    this.sendOrderToServer();
  },
  onDragEnd: function onDragEnd() {
    this.draggingIndex = null;
  },
  sendOrderToServer: function sendOrderToServer() {
    var _this2 = this;

    var orderedIds = this.banks.map(function (b) {
      return b.id;
    });

    fetch("/gateway-order-config/reorder", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-csrf-token": this.csrf_token
      },
      body: (0, _stringify2.default)({ ordered_ids: orderedIds })
    }).then(function (res) {
      return res.json();
    }).then(function (data) {
      if (data.success) {
        _this2.banks = data.gateways;
      } else {
        console.error("Reorder failed", data);
      }
    }).catch(function (err) {
      console.error("Reorder error", err);
    });
  },
  toggleStatus: function toggleStatus(bank) {
    var _this3 = this;

    var id = String(bank.id);

    var isHidden = this.hiddenGatewayIds.includes(id);

    var action = isHidden ? "activate" : "deactivate";

    if (isHidden) {
      this.localHiddenGatewayIds = this.localHiddenGatewayIds.filter(function (gid) {
        return gid !== id;
      });
    } else {
      this.localHiddenGatewayIds = [].concat((0, _toConsumableArray3.default)(this.localHiddenGatewayIds), [id]);
    }

    fetch("/gateway-order-config/" + bank.id + "/status/" + action, {
      method: "POST",
      headers: {
        "x-csrf-token": this.csrf_token
      }
    }).then(function (res) {
      return res.json();
    }).then(function (data) {
      if (!data.success) throw new Error("Failed");

      _this3.localHiddenGatewayIds = data.gateways_hidden_on_checkout || [];
    }).catch(function () {
      if (isHidden) {
        _this3.localHiddenGatewayIds.push(id);
      } else {
        _this3.localHiddenGatewayIds = _this3.localHiddenGatewayIds.filter(function (gid) {
          return gid !== id;
        });
      }
    });
  },
  formatDate: function formatDate(date) {
    if (!date) return "";
    return new Date(date).toLocaleDateString();
  },
  filterBanks: function filterBanks() {}
});
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_vm._m(0),_vm._v(" "),_c('hr',{staticClass:"bank-page-divider"}),_vm._v(" "),_c('div',{staticClass:"bank-table-wrap"},[_c('div',{staticClass:"bank-toolbar"},[_c('div',{staticClass:"bank-search-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],attrs:{"placeholder":"Search"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"bank-filter-btn",on:{"click":_vm.filterBanks}},[_vm._v("\n            Apply filter\n          ")])]),_vm._v(" "),_c('table',{staticClass:"bank-tbl"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredBanks),function(bank,index){return _c('tr',{key:bank.id,class:{ dragging: _vm.draggingIndex === index },attrs:{"data-id":bank.id,"draggable":"true"},on:{"dragstart":function($event){return _vm.onDragStart(index)},"dragover":function($event){$event.preventDefault();return _vm.onDragOver(index)},"drop":function($event){return _vm.onDrop(index)},"dragend":_vm.onDragEnd}},[_c('td',{staticClass:"bank-drag"},[_vm._v("☰")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"bank-name-cell"},[_c('span',{staticClass:"bank-avatar"},[_vm._v("\n                    "+_vm._s(bank.name.charAt(0))+"\n                  ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(bank.name))])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatDate(bank.inserted_at)))]),_vm._v(" "),_c('td',[(!_vm.hiddenGatewayIds.includes(String(bank.id)))?_c('span',{staticClass:"bank-status-active"},[_vm._v("\n                  ● Active\n                ")]):_c('span',{staticClass:"bank-status-inactive"},[_vm._v(" ● Inactive ")])]),_vm._v(" "),_c('td',[_c('label',{staticClass:"bank-toggle",on:{"click":function($event){return _vm.toggleStatus(bank)}}},[_c('span',{staticClass:"bank-toggle-track",class:!_vm.hiddenGatewayIds.includes(String(bank.id))
                        ? 'bank-toggle-track--on'
                        : 'bank-toggle-track--off'},[_c('span',{staticClass:"bank-toggle-thumb",class:!_vm.hiddenGatewayIds.includes(String(bank.id))
                          ? 'bank-toggle-thumb--on'
                          : 'bank-toggle-thumb--off'})])])])])}),0)])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bank-page-header"},[_c('div',[_c('h3',{staticClass:"bank-page-title"},[_vm._v("Gateways")]),_vm._v(" "),_c('p',{staticClass:"bank-page-subtitle"},[_vm._v("\n            A list of all gateways in the checkout\n          ")])])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Order")]),_vm._v(" "),_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Banks")]),_vm._v(" "),_c('th',[_vm._v("Date Added")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Actions")])])])}]
__vue__options__._scopeId = "data-v-289fd4cd"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-289fd4cd", __vue__options__)
  } else {
    hotAPI.reload("data-v-289fd4cd", __vue__options__)
  }
})()}